<div class="container">

  <app-header-dialog [iconName]="'store_mall_directory'">
    Mover para
  </app-header-dialog>

  <div class='content'>

    <mat-select (ngModelChange)='selectFolder($event)' [ngModel]="selectedFolder"
      style="background-color: whitesmoke; padding: 5px 0 5px 5px;">
      <mat-option *ngFor="let folder of folders" [value]="folder.id">
        {{ folder.name }}
      </mat-option>
    </mat-select>

    <div style="margin-top: 20px; margin-left: 20px;" *ngIf="selectedFolder">
      <div>Selecionado:</div>
      <div>{{selectedFolder.name}}</div>
    </div>

  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button mat-raised-button class="flat-button" mat-dialog-close (click)="matDialogRef.close([ selectedFolder ])">
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>